{
  "dss": {
    "footer": {
      "legalEntity": "Andreas Stihl (Pty) Ltd"
    }
  }
}
